(() => {
  const sharpenMobileHero = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const heroImage = document.querySelector('main > .shopify-section:first-child .banner__media > img');
    if (!heroImage) return;

    /* The mobile hero uses object-fit: cover, so it needs a wider source than the viewport. */
    heroImage.setAttribute('sizes', '200vw');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sharpenMobileHero, { once: true });
  } else {
    sharpenMobileHero();
  }
})();
